import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useAnchor } from '$contexts/anchor';
import { useLocale } from '$contexts/locale.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const AwardsModuleLandingSlideNavigationBottom = ({ anchors }) => {
    // contexts
    const { translate: t } = useLocale();

    // references
    const { current } = useAnchor();

    // state
    const [ nextTitle, setNextTitle ] = useState('');
    const [ nextSlug, setNextSlug ] = useState('');

    // hooks
    useEffect(() => {
        const currentAnchorIndex = anchors.findIndex(anchor => anchor?.article?.slug === current);
        setNextSlug(currentAnchorIndex > -1 ? anchors?.[currentAnchorIndex + 1]?.article?.slug : '');
        setNextTitle(currentAnchorIndex > -1 ? anchors?.[currentAnchorIndex + 1]?.article?.title : '');
    }, [ anchors, current ]);

    // render
    if (!nextTitle) {
        return null;
    }

    return (
        <nav className='md:hidden bg-black flex items-center sticky w-full bottom-0 z-10'>
            <div className='layout-container w-full'>
                <div className='px-10 sm:px-20 py-18'>
                    <div className='flex items-start text-white'>
                        <p className='w-1/4 type-style-awards-tiny-uppercase'>
                            {t('Next')}
                        </p>

                        <p className='w-3/4 type-style-awards-subheading-sans-uppercase -mt-2'>
                            <a href={`#${nextSlug}`}>
                                {nextTitle}
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </nav>
    );
};


/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

AwardsModuleLandingSlideNavigationBottom.propTypes = {
    anchors: PropTypes.array
};

export default AwardsModuleLandingSlideNavigationBottom;
